import React from "react";
import Progress5Svg from "../../../assets/svgicons/progress-bar/progress_bar_5.svg";

const Progress5 = (props) => {
  return <img src={Progress5Svg} alt="Progress 5" {...props} />;
};

export default Progress5;
